import RootStore from '@App/stores/root-store'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { ExportType } from '@App/enum/export-type'
import { getExportFormats } from '@App/api/routes/search'
import { Option } from '@Components/Fields/Radio'

export default class ExportStore {
    private rootStore: RootStore

    private _exportType: ExportType

    private _exportFormats: Option[] = []

    constructor(rootStore: RootStore) {
        makeObservable<ExportStore, '_exportType' | '_exportFormats'>(this, {
            _exportType: observable,
            _exportFormats: observable,
            loadExportFormats: action,
        })

        this.rootStore = rootStore
    }

    public loadExportFormats = async () => {
        this.rootStore.preloaderStore.openTransparentPreloader(true)
        const exportFormatsResponse = await getExportFormats(this._exportType)
        runInAction(() => {
            this._exportFormats = exportFormatsResponse.data.data.map((exportFormat, index) => ({
                value: exportFormat.value,
                label: exportFormat.label,
                description: exportFormat.description,
                id: index,
            }))
        })
        this.rootStore.preloaderStore.openTransparentPreloader(false)
    }

    setExportType(type: ExportType) {
        this._exportType = type
    }

    get exportType() {
        return this._exportType
    }

    get exportFormats(): Option[] {
        return this._exportFormats
    }
}
